import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { Currency, DistanceMetrics, LocalStorageKeys } from 'src/types'

import { PeriodChartInMonth } from 'src/components/HomeCharBar/types'

import { UserReducerState } from 'src/store/reducers/UserReducer/types'

const initialState: UserReducerState = {
  currency:
    (localStorage.getItem(LocalStorageKeys.CURRENCY) as Currency) ||
    Currency.USD,
  distanceMetric:
    (localStorage.getItem(
      LocalStorageKeys.DISTANCE_METRICS,
    ) as DistanceMetrics) || DistanceMetrics.KM,
  chartPeriodHome:
    (localStorage.getItem(
      LocalStorageKeys.PERIOD_HOME_CHART,
    ) as PeriodChartInMonth) || PeriodChartInMonth.THREE_MONTH,
  activeCar: localStorage.getItem(LocalStorageKeys.ACTIVE_CAR) || 'none',
  preferList: Number(localStorage.getItem(LocalStorageKeys.PREFER_LIST)) || 0,
  isStarredHide: localStorage.getItem(LocalStorageKeys.STARRED_HIDE) === 'true',
  isContactsHide:
    localStorage.getItem(LocalStorageKeys.CONTACTS_HIDE) === 'true',
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setCurrency: (state, action: PayloadAction<string>) => {
      localStorage.setItem(LocalStorageKeys.CURRENCY, action.payload)
      state.currency = action.payload
    },
    setDistanceMetric: (state, action: PayloadAction<DistanceMetrics>) => {
      localStorage.setItem(LocalStorageKeys.DISTANCE_METRICS, action.payload)
      state.distanceMetric = action.payload
    },
    setActiveCar: (state, action: PayloadAction<string>) => {
      localStorage.setItem(LocalStorageKeys.ACTIVE_CAR, action.payload)
      state.activeCar = action.payload
    },
    setIsPreferList: (state, action: PayloadAction<number>) => {
      localStorage.setItem(LocalStorageKeys.PREFER_LIST, `${action.payload}`)
      state.preferList = action.payload
    },
    setIsStarredHide: (state, action: PayloadAction<boolean>) => {
      localStorage.setItem(LocalStorageKeys.STARRED_HIDE, `${action.payload}`)
      state.isStarredHide = action.payload
    },
    setIsContactsHide: (state, action: PayloadAction<boolean>) => {
      localStorage.setItem(LocalStorageKeys.CONTACTS_HIDE, `${action.payload}`)
      state.isContactsHide = action.payload
    },
    setChartPeriodHome: (state, action: PayloadAction<PeriodChartInMonth>) => {
      localStorage.setItem(LocalStorageKeys.PERIOD_HOME_CHART, action.payload)
      state.chartPeriodHome = action.payload
    },
  },
})

export default userSlice.reducer
